// removed by extract-text-webpack-plugin
module.exports = {"Content":"_1WbTT8YiyGY0HWVFQj-PTJ","Claim":"_17TrtJn95Gqa_5RdPq5se6","Column":"_2mXtH1AG_1_5R7XJsf3IHo","Search":"_1HVTr_vCvgYCLA47fJaU5E","SearchButton":"_3iPoLCmoC-RIBqZUKQr8NE","Resources":"TmoGGZ_GkHsWTpBlqsdGu","Row":"hIm6o8NJ8gEsImkbAzpoG","List":"_1F4Y3THVkjpFodmQfFgtrH","Block":"UCSurTvMgigRZIu-_AvYS","Select":"_3L1hhSRRPEsOEc5Wq9Qfuk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Resources/Resources.css
// module id = 421
// module chunks = 0